<template>
  <v-container fluid id="MyTruckRequests" class="pa-0 pa-sm-3">
    <v-row wrap>
      <v-col cols="12" xs="12" class="headline pb-0">
        My Truck Service Requests
        <v-btn
          color="primary"
          small
          class="ml-4"
          to="/truck-requests/service/new"
          ><v-icon small left>add</v-icon> New</v-btn
        >
      </v-col>
      <v-col cols="12" xs="12" class="">
        <v-card>
          <v-tabs>
            <v-tab @click="truckServiceRequestType('open')">Open</v-tab>
            <v-tab @click="truckServiceRequestType('closed')">Closed</v-tab>
            <v-tab @click="truckServiceRequestType('cancelled')"
              >Cancelled</v-tab
            >
          </v-tabs>
          <v-divider></v-divider>
          <v-data-table
            :items="currentTruckServiceRequests"
            :loading="loadingTruckServiceRequests"
            loading-text="Loading....please wait."
            :headers="headers"
            disable-sort
          >
            <template v-slot:item.orderNumber="{ item }">
              <span class="subtitle-2">#{{ item.orderNumber }}</span>
            </template>
            <template v-slot:item.photos="{ item }">
              <service-photos :photos="item.photos" />
            </template>
            <template v-slot:item.orderDate="{ item }">
              {{ item.orderDate.toDate() | moment("MMM Do, YYYY") }}
            </template>
            <template v-slot:item.status="{ item }">
              <status-chip :status="item.status" />
            </template>
            <template
              v-slot:item.closingNotes="{ item }"
              v-if="type == 'closed'"
            >
              {{ item.closingNotes }}
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import fb from "@/main";
import { mapState } from "vuex";
import statusChip from "@/components/StatusChip";
import servicePhotos from "@/components/truckRequests/servicePhotos";
export default {
  components: {
    statusChip,
    servicePhotos,
  },
  data() {
    return {
      type: "open",
      dialog: false,
      loadingTruckServiceRequests: true,
      truckServiceRequests: [],
      headers: [
        {
          text: "Order",
          align: "left",
          value: "orderNumber",
          sortable: false,
          width: 60,
        },
        { text: "Truck", value: "truck" },
        { text: "Description", value: "notes" },
        { text: "Photos", value: "photos", sortable: false, width: 140 },
        { text: "Request Date", value: "orderDate", width: 180 },
        { text: "Closing Notes", value: "closingNotes" },
        { text: "Status", value: "status", align: "center", width: 180 },
      ],
    };
  },
  computed: {
    currentTruckServiceRequests: function() {
      return this.truckServiceRequests.filter((wo) => wo.status == this.type);
    },
    ...mapState(["user"]),
  },
  async created() {
    this.getTruckServiceRequests();
  },
  methods: {
    async getTruckServiceRequests() {
      try {
        const truckServiceRequests = await fb.db
          .collection("truckService")
          .where("orderedBy.uid", "==", this.user.uid)
          .orderBy("orderDate", "desc")
          .limit(50)
          .get();
        this.truckServiceRequests = [];
        truckServiceRequests.forEach((u) => {
          this.truckServiceRequests.push({
            ...u.data(),
          });
        });
        this.loadingTruckServiceRequests = false;
      } catch (error) {
        alert(error);
        console.log(error);
        this.loadingTruckServiceRequests = false;
      }
    },
    truckServiceRequestType(type) {
      this.type = type;
    },
  },
};
</script>
